import React from 'react'
import { useContext } from 'react';
import { GlobalState } from '../../GlobalState';
import { api } from '../../util/urlConfig';
import moment from 'moment';
import { useEffect } from 'react';
import './supplierFeedbackNotifyComponent.css'
import { useState } from 'react';
import axios from '../../helpers/axios';

export default function CustomerAccountNotifyComponent({ id }) {
    const [customerAccountDetail, setCustomerAccountDetail] = useState(null);

    //Import Global State
    const state = useContext(GlobalState);
    const [allCustomers] = state.customerAPI.allCustomers;

    const getCustomer = (id) => {
        return allCustomers.filter(customer => customer.id === id);
    }

    const getAccDetail = async (cusId) => {
        const res = await axios.get(`/customeraccount/${cusId}`);
        setCustomerAccountDetail(res.data.response.data)
    }

    useEffect(() => {
        getAccDetail(id);
    }, [id, allCustomers])

    return (
        <>
            {
                customerAccountDetail ?
                    <div className='notify-main-container'>
                        <div className='notify-content-area'>
                            <img className='notify-img' src={customerAccountDetail.customer && customerAccountDetail.customer.upload_image ? api + "/" + customerAccountDetail.customer.upload_image.image_url : "/img/dummy_avatar.png"} alt="avatar" />
                            <div className='notify-content-detail'>
                                <div className='notify-name'>
                                    {
                                        customerAccountDetail.customer ? getCustomer(customerAccountDetail.customer.id)[0].first_name + " " + getCustomer(customerAccountDetail.customer.id)[0].last_name
                                            : customerAccountDetail.created_by ? customerAccountDetail.created_by.first_name + " " + customerAccountDetail.created_by.last_name : ""
                                    }
                                </div>


                                <div className='notify-subname'>You have paid Rs. {customerAccountDetail.advance_amount} for advanced. Thank you.</div>
                                <div className='notify-subname'>
                                    <i className='uil uil-clock'></i>
                                    <span>{moment(customerAccountDetail.created_at).format('DD-MM-YYYY')}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    : <></>
            }
        </>
    )
}
